import { find } from "linkifyjs";

/** First http(s) URL in text (for link preview card). */
export function firstHttpUrlFromText(text: string): string | null {
  const t = text.trim();
  if (!t) return null;
  const matches = find(t);
  for (const m of matches) {
    if (!m.isLink || m.type !== "url") continue;
    if (/^https?:\/\//i.test(m.href)) return m.href;
  }
  return null;
}

/** True when the entire message is a single URL recognized by linkify. */
export function isTextOnlyUrl(text: string): boolean {
  const t = text.trim();
  if (!t) return false;
  const matches = find(t);
  const urls = matches.filter((m) => m.isLink && m.type === "url");
  return urls.length === 1 && t === urls[0].value;
}
